import { useEffect, useRef, useState } from "react";
import { ButtonDef } from "../../core/form/ButtonDef";
import { Icon } from "../../core/ui/icons";
import { closestIndex } from "../../core/utils/dom";
import { Page } from "../Page";

import { api } from "../../api/api";
import { Table } from "../../core/ui/Table";
import { CustomCol, GenericCol, LastUpdatedCol } from "../../layout/TableCells";
import { titleCase } from "title-case";
import { HistoricalDate } from "../../core/ui/HistoricalDate";
import { useRefresh } from "../../core/hooks/useRefresh";

function LargeButtons(props: {
	buttons: ButtonDef[],
}) {

	const buttons = [];
	let i = 0;
	for(let b of props.buttons) {

		const icon = (b.icon) ? <Icon type={b.icon} /> : undefined;

		buttons.push(
			<button
				key={i++}
				data-index={i}
				className="button flat flex vert"
			>
				{icon}
				<span>{b.title}</span>
			</button>
		);
	}


	return (
		<div 
			className="large-buttons flex wrap"
			onClick={(e) => {
				const i = closestIndex(e.target, ".button");
				if (i < 0) return;

				const url = props.buttons[i].url;
				if (url) {
					document.location.href = url;
				}
			}}
		>
			{buttons}
		</div>
	)
}

export function Settings(props: {

}) {

	const [versions, setVersions] = useState<any>();

	const refresh = useRefresh();

	useEffect(() => {
		api.version({}).then((obj) => {
			setVersions(obj);
		}).catch((e) => {

		});
	}, []);

	return (
		<Page 
			compact={true}
			title={{
				text: "Settings",
				icon: "settings_color",
			}}
		>


			<LargeButtons
				buttons={[
					{ icon: "workflow_color", title: "Workflows", url: "/admin/workflows/" },
					{ icon: "form_color", title: "Forms", url: "/admin/forms/" },
					{ icon: "report_color", title: "Reports", url: "/admin/reports/" },
					{ icon: "reference_color", title: "Reference Tables", url: "/admin/ref/" },
					{ icon: "resources_color", title: "Resources", url: "/admin/resources/" },
					{ icon: "code_color", title: "Scripts", url: "/admin/scripts/" },
					
				]}
			/>

			{
				versions &&
				<>
					
					<table className="margin-top-20">
						<tbody>
							<tr>
								<th>Version</th>
							</tr>
							<tr>
								<td>Web</td>
								<td>{versions.version_web}</td>
							</tr>
							<tr>
								<td>API</td>
								<td>{versions.version_api}</td>
							</tr>
						</tbody>
					</table>

					{
						versions && versions.alerts && versions.alerts.length > 0 &&
						<Table
							interactive={true}
							className="margin-top-10"
							cols={[
								CustomCol({
									title: (c) => {
										return "Priority";
									},
									value: (r, c) => {
										let icon;
										if (r.priority === "high") {
											icon = <Icon type="warning" />
										}
										return (
											<div className="flex horiz align-center gap-2">
												{icon}
												{titleCase(r.priority)}
											</div>
										);
									},
								}),
								GenericCol("Status", "name"),
								GenericCol("Count", "count"),
								LastUpdatedCol(),
								CustomCol({
									title: (c) => "Actions",
									value: (r, c) => {
										if (r.ack) {
											return <Icon type="tick" />
										}

										return (
											<button
												className="primary"
												onClick={() => {
													api.status_delete({
														id: r.id,
													}).then(() => {
														r.ack = true;
														refresh.refresh();
													}).catch(() => {

													})
												}}
											>Acknowledge</button>
										)
									},
								})
							]}
							items={versions.alerts}

							render={{
								getRowAttrs: (r: any) => {
									if (r.priority === "high" && !r.ack) {
										return {
											className: "bg-error text-inverse"
										}
									}
								}
							}}
							
						/>						
					}

				</>
			}

		</Page>
	);
}